/**
 * PopoverResizeHandle — bottom-right corner grip that starts a useCornerResize drag.
 *
 * Purely presentational: the actual size math lives in `useCornerResize`. Rendered as the
 * last child inside a popover's outer box (which must be `position: relative` — see
 * `.popover-resize-handle` in components.css), absolutely pinned to that box's own corner
 * regardless of the resize target being the box itself.
 */
interface PopoverResizeHandleProps {
  onPointerDown: (e: React.PointerEvent) => void;
}

export function PopoverResizeHandle({ onPointerDown }: PopoverResizeHandleProps) {
  return (
    <div className="popover-resize-handle" onPointerDown={onPointerDown} aria-hidden>
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M9 1L1 9M9 5L5 9" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      </svg>
    </div>
  );
}
